import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function PortfolioPlPerformanceChartHelp() {
    return (
        <IconTooltip>
            <div>
                This chart displays the Realised and Unrealised Profit/Loss (in
                bps) for orders in a list.
            </div>
        </IconTooltip>
    );
}
